// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login-container input:-webkit-autofill,\n.login-container input:-webkit-autofill:hover,\n.login-container input:-webkit-autofill:focus,\n.login-container input:-webkit-autofill:active {\n  -webkit-text-fill-color: #1f2937 !important;\n  -webkit-box-shadow: 0 0 0 1000px #fff inset !important;\n          box-shadow: 0 0 0 1000px #fff inset !important;\n  -webkit-transition: background-color 9999s ease-out 0s;\n  transition: background-color 9999s ease-out 0s;\n}", ""]);
// Exports
module.exports = exports;
